module.exports = __webpack_public_path__ + "img/ИФ-1(А)-026-m.68d49002.png";